import React from "react"
import { graphql } from "gatsby"

import IndustryPageTemplate from "../../components/industries/IndustryPageTemplate"
import buildData from "../../data/industries/real-estate"

const RealEstate = ({ data }) => (
  <IndustryPageTemplate
    data={buildData({
      heroImage: data.heroImage?.childImageSharp?.gatsbyImageData,
      challengeImages: [
        data.challenge1?.childImageSharp?.gatsbyImageData,
        data.challenge2?.childImageSharp?.gatsbyImageData,
        data.challenge3?.childImageSharp?.gatsbyImageData,
        data.challenge4?.childImageSharp?.gatsbyImageData,
      ],
      solutionImage: data.solutionImage?.childImageSharp?.gatsbyImageData,
      resultsImage: data.resultsImage?.childImageSharp?.gatsbyImageData,
    })}
  />
)

export default RealEstate

export const query = graphql`
  query RealEstateIndustryImages {
    heroImage: file(relativePath: { eq: "industries/real-estate-hero.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF], breakpoints: [750, 1080, 1366, 1920, 2400], quality: 80)
      }
    }
    challenge1: file(relativePath: { eq: "industries/real-estate-challenge-1.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    challenge2: file(relativePath: { eq: "industries/real-estate-challenge-2.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    challenge3: file(relativePath: { eq: "industries/real-estate-challenge-3.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    challenge4: file(relativePath: { eq: "industries/real-estate-challenge-4.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, width: 800, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    solutionImage: file(relativePath: { eq: "industries/real-estate-solution.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
    resultsImage: file(relativePath: { eq: "industries/real-estate-results.jpg" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED, formats: [AUTO, WEBP], quality: 78)
      }
    }
  }
`
